import {useFeatureIsOn} from "@growthbook/growthbook-react";

import {useFlagsCookie} from "@khan/data-cookies";

import type {AppFeatures} from "./app-features.ts";

/**
 * Check the status of a feature flag via GrowthBook and local cookie.
 *
 * If the cookie is set, it overrides the GrowthBook value.
 *
 * @param flagName - The name of the feature as defined in GrowthBook.
 * @returns boolean - true if the feature is enabled, false otherwise.
 */
export function useFlagOrCookie(flagName: keyof AppFeatures): boolean {
    const featureFlag = useFeatureIsOn<AppFeatures>(flagName);
    const flagsCookie = useFlagsCookie(flagName);

    if (flagsCookie.status === "success") {
        if (typeof flagsCookie.value === "boolean") {
            return flagsCookie.value;
        }
    }

    return featureFlag;
}
